module.exports = __webpack_public_path__ + "img/zhen_yu.7ac94ca9.png";